$(document).ready(function(){

  var ids = {},cids = {},designer_url,cur_time;
  cur_time = new Date().getTime();

  history.replaceState('', document.title, window.location.origin + window.location.pathname + window.location.search);
  //stickey Bar
 if($('.pint-pack-option').length > 0 ) {

  	  var fixmeTop = $('.pint-pack-option').offset().top;

      $(window).scroll(function() {

          var currentScroll = $(window).scrollTop();

          if (currentScroll >= fixmeTop) {

              $('.pint-pack-option').addClass('fixedheader');
          } else {

             $('.pint-pack-option').removeClass('fixedheader');
          }
      }); 

   	//add class to remove top padding
   	$('#MainContent').addClass('main-content-special');

 }
  disable_pyf_button();

   $(".byi-design-it").click(function(){
              
     var variant_id=$(".hidden_Personalize").val();
     var encode_variant_id = btoa(variant_id);
     $("#sid").val(encode_variant_id);

     var designer_url=$(".byi-design-it").attr("data-design-url");
     $("#ecre-final-data").attr("action",designer_url);

     var subset = $('#hidden-subset').text();
     var subset_data = subset.split(',');

     var flavor_data = [];
     var selected_products={};

     for(var data=0; data < subset_data.length ; data++  ){

       flavor_data[data] = {"title" : subset_data[data] , "custom_title" :  subset_data[data]  };
       selected_products[data] = subset_data[data];
     }

     var json_selected_products=JSON.stringify(selected_products);
     var  encode_selected_products = btoa(json_selected_products);
     $("#selected_products").val(encode_selected_products);

     var json_custom_flavor=JSON.stringify(flavor_data);
     var  encode_flavor_data  = btoa(json_custom_flavor);
     $("#selected_custom_flavor").val(encode_flavor_data);

     var  flavor_length = subset_data.length;
     var  encode_flover  = btoa(flavor_length);
     $("#selected_custom_flavor_count").val(encode_flover);

     var time =new Date().getTime();
     var  encode_time  = btoa(time);
     $("#current_timestamp").val(encode_time);

     $( "#ecre-final-data" ).submit();


   });




  //Calculate count of full busket and check which pints will be selected(4/8)


  // selected busket will be filled while page load
  return_real_time_filled_busket()
  		//alert(compare_price_4)


  if(compare_price_4 != '$0'){
  	$('.pricing-tag').append('<p class="four-pints">4 Pints - <strike>'+compare_price_4+'</strike><span>'+regular_price_4+'</span></p>');

  }
  else{
  	$('.pricing-tag').append('<p class="four-pints">4 Pints - '+regular_price_4+'</p>');

  }

  if(compare_price_8 != '$0'){
  	$('.pricing-tag').append('<p class="five-pints">8 Pints -  <strike>'+compare_price_8+'</strike><span>'+regular_price_8+'</span></p>');

  }
  else{
  	$('.pricing-tag').append('<p class="five-pints">8 Pints - '+regular_price_8+'</p>');

  }

  if(compare_price_12 != '$0'){
  	$('.pricing-tag').append('<p class="six-pints">12 Pints -  <strike>'+compare_price_12+'</strike><span>'+regular_price_12+'</span></p>');

  }
  else{
  	$('.pricing-tag').append('<p class="six-pints">12 Pints - '+regular_price_12+'</p>');

  }


  calculate_remain_pack();
  //Add to pack button event
  $('.ecre-actions #ecre_add_to_pack').click(function(){

        var count = getCount();
        //console.log('click count');
        //console.log(count);
        if(count < 12){

        //if(count < 8){
          
            /*if(getCookie("selected_pyf") != null){
              if(count>4){
                //open popup 
                $(this).addClass('in-queue');
                document.location='#confirm_action';
                return false          
              }   
            } */
            var product_v_id = $(this).parent().parent().children('.pr_id').text();
            var product_id = $(this).parent().parent().children('.grid-view-item__image-wrapper').attr('id');
            var product_name = $(this).parent().parent().children('.visually-hidden:first').text();
            var num = $(".pack-collection ul").find("li").length;
          	var custom_flavor_a;
           //for custom breakable flavor
            var custom_flavor  = $(this).parent().parent().children('.custom_flavor').text();

          //if not any custom flavor defined
          if( custom_flavor == " blank " || custom_flavor == null || custom_flavor == "blank" ){

            custom_flavor_a = product_name;
          } else{

          	custom_flavor_a = custom_flavor;
          }
          //alert(custom_flavor);
            var json_str,result,cjson_str;
          	product_id = product_id.split('-').pop(-1);

            if(num <= 4){

              var blank_li = '<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li>'
              $('.pack-collection ul#cup').append(blank_li);

            }else if(num <= 8){

              var blank_li = '<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li>'
              $('.pack-collection ul#cup').append(blank_li);

            }

            $('.pack-collection ul li.blank:first').children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0085/7168/2893/files/1-12pintpng.png?6500');
            $('.pack-collection ul li.blank:first').children().children('img').attr('data-id',product_id);
            $('.pack-collection ul li.blank:first').children().children('img').attr('data-vid',product_v_id);
            $('.pack-collection ul li.blank:first').addClass('type-pyp');	
          	$('.pack-collection ul li.blank:first').removeClass('blank');
            //add product and set data-id attr in edit pack section
            $('#list_prod').append('<li><a href="javascript:void(0)" data-vid = "'+product_v_id+'" data-id= "'+product_id+'" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+product_name+'</span></li>');

           ids[product_id] = product_name;

            json_str = JSON.stringify(ids);


            //set product name cookie
            if(getCookie("selected_pints_all") != null){

                result= getCookie("selected_pints_all");
                result = JSON.parse(result);
                result[product_id] = product_name;
                document.cookie = "selected_pints_all="+JSON.stringify(result)+";path="+window.location.pathname;

            }else {

              	document.cookie = "selected_pints_all="+json_str+";path="+window.location.pathname;
            }
          
           custom_flavor_a = custom_flavor_a.replace(/,/,'#comma');
           custom_flavor_a = custom_flavor_a.replace(/\./,'#stop');
           custom_flavor_a = custom_flavor_a.replace(/'/,'#accent');

           cids[product_id] = custom_flavor_a;

            cjson_str = JSON.stringify(cids);

          	//set custom flavor name cookie
            if(getCookie("selected_cflavor") != null){

                result= getCookie("selected_cflavor");
                result = JSON.parse(result);
                result[product_id] = custom_flavor_a;
                document.cookie = "selected_cflavor="+JSON.stringify(result)+";path="+window.location.pathname;

            }else {
              	document.cookie = "selected_cflavor="+cjson_str+";path="+window.location.pathname;
             }

          	//set cookie for variant id
          	if(getCookie("selected_pints_vid") != null){

              result = getCookie("selected_pints_vid");
              result = result+','+product_v_id;
              document.cookie = "selected_pints_vid="+ result+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pints_vid=" + product_v_id+";path="+window.location.pathname;
            }


            //set product id cookie
            if(getCookie("selected_pints") != null){

              result = getCookie("selected_pints");
              result = result+','+product_id;
              document.cookie = "selected_pints="+result+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pints=" + product_id+";path="+window.location.pathname;
            }

        } else{

            alert("Maximum Pints Added..");
        }

        calculate_remain_pack()

  });
  
  
  function addanywayaction(){
  		//console.log('called another');
        var count = getCount();
    
        if($('.in-queue').attr('data-type') == 'pyf'){
          var subset = $('.in-queue').parent().siblings('.ecre-desc').find('#hidden-subset:first').text();
    	var title = $(this).parent().siblings('.product-card__title').text();
    	//console.log('subset');
    	//console.log(subset);
    	var subset_data = subset.split(',');
    	var subsets_length = subset_data.length
        
        if(subsets_length == 8){
			$('.create-block-radio-four').css('display','none') 
            $('.create-block-radio-twelve').css('display','none')
        }else if(subsets_length == 4){
			$('.create-block-radio-eight').css('display','none')
            $('.create-block-radio-twelve').css('display','none')
        }else{
        	$('.create-block-radio-four').css('display','none')
            $('.create-block-radio-eight').css('display','none')
       }
    
       final_data = {};selected_products_array={};
    
    	$('.pint-pack-option').css('display','block');
    
    	//console.log('length')
    	//console.log($('#list_prod').length)
        var product_index ='';
    	for(var data=0; data < subset_data.length ; data++  ){
              	
          final_data[data] = {"title" : subset_data[data] , "custom_title" :  subset_data[data]  };
          selected_products_array[data] = subset_data[data];
          
          
          if(data+1 == subset_data.length){
          	product_index = product_index+data;		
          }else{          
          	product_index = product_index+data+','
          }
           //add product and set data-id attr in edit pack section
            //$('#list_prod').append('<li><a href="javascript:void(0)" data-vid = "" data-id= "" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+subset_data[data]+'</span></li>');
          //var blank_li = '<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li>';
              //$('.pack-collection ul#cup').append(blank_li);
          $('.pack-collection ul li.blank:first').children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0085/7168/2893/files/1-12pintpng.png?6500');
          //$('.pack-collection ul').addClass('type-pyf');
          $('.pack-collection ul li.blank:first').addClass('type-pyf');
            //$('.pack-collection ul li.blank:first').children().children('img').attr('data-id',product_id);
            //$('.pack-collection ul li.blank:first').children().children('img').attr('data-vid',product_v_id);
          $('.pack-collection ul li.blank:first').removeClass('blank');
          $('#list_prod').append('<li><a href="javascript:void(0)" class="type-pyf" data-vid = "" data-id= "" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+subset_data[data].replace(/\|/g, " ")+'</span></li>');
		  //$('#list_prod ').addClass('type-pyf');


        }

    	//console.log('final_data');
    	//console.log(final_data);
    	//console.log('selected_products_array');
    	//console.log(selected_products_array);
    	//console.log("product indesx");
    	//console.log(product_index);
    	var json_selected_products=JSON.stringify(selected_products_array);
              	
        var json_custom_flavor=JSON.stringify(final_data);

        var  encode_final_data  = btoa(json_custom_flavor);
        var  encode_selected_products_array = btoa(json_selected_products);


        $("#selected_custom_flavor").val(encode_final_data);

        $("#selected_products").val(encode_selected_products_array);
		$('#ecre-final-data').attr('action',base_url);
        var subsets_length = subset_data.length
       //var json_flavor_count =JSON.stringify(selected_custom_flavor_lenght);

        //var  encode_flover  = btoa(json_flavor_count);
        //$("#selected_custom_flavor_count").val(encode_flover);
        
        //console.log('pints length');
    	//console.log(selected_custom_flavor_lenght);
             
          
            //$("#current_timestamp").val(encode_time);			
    
    		//ids[product_id] = product_name;

            json_str = JSON.stringify(selected_products_array);


            //set product name cookie
            if(getCookie("selected_pints_all") != null){
              
              
                ///alert popup
                result= getCookie("selected_pints_all");
                result = JSON.parse(result);
                //result[product_id] = product_name;
                document.cookie = "selected_pints_all="+JSON.stringify(selected_products_array)+";path="+window.location.pathname;
				//document.cookie = "selected_pints_all="+JSON.stringify(selected_products_array)+";path="+window.location.pathname;

            }else {

              	document.cookie = "selected_pints_all="+json_str+";path="+window.location.pathname;
            }
    
    		//custom_flavor_a = custom_flavor_a.replace(/,/,'#comma');
          	//custom_flavor_a = custom_flavor_a.replace(/\./,'#stop');
          	//custom_flavor_a = custom_flavor_a.replace(/'/,'#accent');         

            //cids[product_id] = custom_flavor_a;

            cjson_str = JSON.stringify(selected_products_array);

          	//set custom flavor name cookie
            if(getCookie("selected_cflavor") != null){

                result= getCookie("selected_cflavor");
                result = JSON.parse(result);
                document.cookie = "selected_cflavor="+JSON.stringify(selected_products_array)+";path="+window.location.pathname;

            }else {

              	document.cookie = "selected_cflavor="+cjson_str+";path="+window.location.pathname;
            }
    		
          	if(getCookie("selected_collection_name") != null){
              	document.cookie = "selected_collection_name=" + title+";path="+window.location.pathname;
            }else{
            	document.cookie = "selected_collection_name=" + title+";path="+window.location.pathname;            
            }
    		
    		//set cookie for variant id
         	if(getCookie("selected_pyf") != null){
              document.cookie = "selected_pyf="+ JSON.stringify(selected_products_array)+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pyf=" + cjson_str+";path="+window.location.pathname;
            }


            //set product id cookie
            if(getCookie("selected_pints") != null){

              result = getCookie("selected_pints");
              result = result+','+product_id;
              document.cookie = "selected_pints="+ result+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pints=" + product_index+";path="+window.location.pathname;
            } 
    		
    		//set cookie for variant id
          	if(getCookie("selected_pints_vid") != null){
              document.cookie = "selected_pints_vid="+ JSON.stringify(selected_products_array)+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pints_vid=" + cjson_str+";path="+window.location.pathname;
            }
    
    				
	
        }else{
        
        	if(count < 8){
          
            if(getCookie("selected_pyf") != null){
              //open popup 
              $(this).addClass('in-queue');
              document.location='#confirm_action'
              
				return false;
            }

            var product_v_id = $('.in-queue').parent().parent().children('.pr_id').text();
            var product_id = $('.in-queue').parent().parent().children('.grid-view-item__image-wrapper').attr('id');
            var product_name = $('.in-queue').parent().parent().children('.visually-hidden:first').text();
            var num = $(".pack-collection ul").find("li").length;
          	var custom_flavor_a;
           //for custom breakable flavor
            var custom_flavor  = $('.in-queue').parent().parent().children('.custom_flavor').text();

          //if not any custom flavor defined
          if( custom_flavor == " blank " || custom_flavor == null || custom_flavor == "blank" ){

            custom_flavor_a = product_name;
          } else{

          	custom_flavor_a = custom_flavor;
          }
          //alert(custom_flavor);
            var json_str,result,cjson_str;
          	product_id = product_id.split('-').pop(-1);

            if(num <= 4){

              var blank_li = '<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li>'
              $('.pack-collection ul#cup').append(blank_li);

            } else if(num <= 8){

              var blank_li = '<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li>'
              $('.pack-collection ul#cup').append(blank_li);

            }

            $('.pack-collection ul li.blank:first').children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0085/7168/2893/files/1-12pintpng.png?6500');
            $('.pack-collection ul li.blank:first').children().children('img').attr('data-id',product_id);
            $('.pack-collection ul li.blank:first').children().children('img').attr('data-vid',product_v_id);
            $('.pack-collection ul li.blank:first').addClass('type-pyp');	
          	$('.pack-collection ul li.blank:first').removeClass('blank');

            //add product and set data-id attr in edit pack section
            $('#list_prod').append('<li><a href="javascript:void(0)" data-vid = "'+product_v_id+'" data-id= "'+product_id+'" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+product_name+'</span></li>');

           ids[product_id] = product_name;

            json_str = JSON.stringify(ids);


            //set product name cookie
            if(getCookie("selected_pints_all") != null){

                result= getCookie("selected_pints_all");
                result = JSON.parse(result);
                result[product_id] = product_name;
                document.cookie = "selected_pints_all="+JSON.stringify(result)+";path="+window.location.pathname;

            }else {

              	document.cookie = "selected_pints_all="+json_str+";path="+window.location.pathname;
            }
			
          
          	custom_flavor_a = custom_flavor_a.replace(/,/,'#comma');
          	custom_flavor_a = custom_flavor_a.replace(/\./,'#stop');
          	custom_flavor_a = custom_flavor_a.replace(/'/,'#accent');         

          	cids[product_id] = custom_flavor_a;

            cjson_str = JSON.stringify(cids);

          	//set custom flavor name cookie
            if(getCookie("selected_cflavor") != null){

                result= getCookie("selected_cflavor");
                result = JSON.parse(result);
                result[product_id] = custom_flavor_a;
                document.cookie = "selected_cflavor="+JSON.stringify(result)+";path="+window.location.pathname;

            }else {
              	document.cookie = "selected_cflavor="+cjson_str+";path="+window.location.pathname;
            }

          	//set cookie for variant id
          	if(getCookie("selected_pints_vid") != null){

              result = getCookie("selected_pints_vid");
              result = result+','+product_v_id;
              document.cookie = "selected_pints_vid="+ result+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pints_vid=" + product_v_id+";path="+window.location.pathname;
            }


            //set product id cookie
            if(getCookie("selected_pints") != null){

              result = getCookie("selected_pints");
              result = result+','+product_id;
              document.cookie = "selected_pints="+result+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pints=" + product_id+";path="+window.location.pathname;
            }

        } else{

            alert("Maximum Pints Added..");
        }
      
      }
	  $('.in-queue').removeClass('in-queue');
         

        calculate_remain_pack()	  
  
  }
  
  $('.ecre-actions #ecre_pick_flavour').click(function(){
    
		//console.log('pick flavour clicked');       
     	//console.log('Current count');   
    	    	

        var count = getCount();
    
    	if(count < 8 ){
    
    	//console.log(count);
    	var subset = $(this).parent().siblings('.ecre-desc').find('#hidden-subset').text();
    	var title = $(this).parent().siblings('.product-card__title').text();
        if( $('.pack-collection ul li:first').hasClass('type-pyp') === true || $('.pack-collection ul li:first').hasClass('type-pyf') === true) {			
          
          if(count>4){
            //open popup 
           // $(this).addClass('in-queue');
            //document.location='#confirm_action';
            //return false          
          }          	
          
        }
       
        var subset = $(this).parent().siblings('.ecre-desc').find('#hidden-subset:first').text();
    
    	//console.log('subset');
    	//console.log(subset);
    	var subset_data = subset.split(',');
    	var subsets_length = subset_data.length
        var start = 0;
          
          //console.log('subset length');
          //console.log(subsets_length);
          total_length = subsets_length+count;
          //console.log(total_length);
          if(total_length > 8){
          	alert("You can't add this collection to pack");
            return false;
          } 
          
        /*if(subsets_length == 4){
			$('.create-block-radio-eight').css('display','none')
        }else if(subsets_length == 8){
        	$('.create-block-radio-four').css('display','none')        
        }else{
        	return false;
        }*/
    
        final_data = {};selected_products_array={};selected_products_wto={};
    
    	$('.pint-pack-option').css('display','block');
    
    	//console.log('length')
    	//console.log($('#list_prod').length)
        var product_index ='';
    	//subset_data.length
        
        //check if collection already added then get last index
        if(getCookie("selected_pints_vid") != null){
          var start_index = getCookie("selected_pints_vid");   
          start_index = start_index.pop();          
          if(start_index == 3){
            start = start_index; 
            start++;
          }
        }
          
          if(subset_data.length == 8 ){
          	$('.create-block-radio .create-block-radio-four').css('display','none');
          
          }
          
          //console.log('start');
          //console.log(start);
         
    
    	for(var data=0; data < subset_data.length ; data++  ){
              	
          final_data[start] = {"title" : subset_data[data].replace(/\|/g, " ") , "custom_title" :  subset_data[data]  };
          selected_products_array[start] = subset_data[data];
          selected_products_wto[start] = subset_data[data].replace(/\|/g, " ");
                   
          if(data+1 == subset_data.length){
          	product_index = product_index+start;		
          }else{          
          	product_index = product_index+start+','
          }
           //add product and set data-id attr in edit pack section
            //$('#list_prod').append('<li><a href="javascript:void(0)" data-vid = "" data-id= "" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+subset_data[data]+'</span></li>');
          //var blank_li = '<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li>';
              //$('.pack-collection ul#cup').append(blank_li);
          $('.pack-collection ul li.blank:first').children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0085/7168/2893/files/1-12pintpng.png?6500');
          //$('.pack-collection ul').addClass('type-pyf');
          $('.pack-collection ul li.blank:first').addClass('type-pyf');
          $('.pack-collection ul li.blank:first').css('display','block');
            //$('.pack-collection ul li.blank:first').children().children('img').attr('data-id',product_id);
            //$('.pack-collection ul li.blank:first').children().children('img').attr('data-vid',product_v_id);
          $('.pack-collection ul li.blank:first').removeClass('blank');
          $('#list_prod').append('<li><a href="javascript:void(0)" class="type-pyf" data-vid = "" data-id= "" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+subset_data[data].replace(/\|/g, " ")+'</span></li>');
		  //$('#list_prod ').addClass('type-pyf');
			start++;
          	//console.log('steps');
          	//console.log(data);

        }

    	// console.log('final_data');
    	// console.log(final_data);
    	// console.log('selected_products_array');
    	// console.log(selected_products_array);
    	// console.log("product indesx");
    	// console.log(product_index);
    	var json_selected_products = JSON.stringify(selected_products_array);
              	
        var json_custom_flavor = JSON.stringify(final_data);

        var  encode_final_data  = btoa(json_custom_flavor);
        var  encode_selected_products_array = btoa(json_selected_products);


        $("#selected_custom_flavor").val(encode_final_data);

        $("#selected_products").val(encode_selected_products_array);
		$('#ecre-final-data').attr('action',base_url);
        var subsets_length = subset_data.length
       //var json_flavor_count =JSON.stringify(selected_custom_flavor_lenght);

        //var  encode_flover  = btoa(json_flavor_count);
        //$("#selected_custom_flavor_count").val(encode_flover);
        
        //console.log('pints length');
    	//console.log(selected_custom_flavor_lenght);
             
          
            //$("#current_timestamp").val(encode_time);			
    
    		//ids[product_id] = product_name;

            json_str = JSON.stringify(selected_products_wto);


            //set product name cookie
            var newresult ={};
    		//set product name cookie
            if(getCookie("selected_pints_all") != null){
                result= getCookie("selected_pints_all");
                result = JSON.parse(result);
                newresult = {...result, ...selected_products_wto}              	
                document.cookie = "selected_pints_all="+JSON.stringify(newresult)+";path="+window.location.pathname;
            }else{
              	document.cookie = "selected_pints_all="+JSON.stringify(selected_products_wto)+";path="+window.location.pathname;
            }
    
    		//custom_flavor_a = custom_flavor_a.replace(/,/,'#comma');
          	//custom_flavor_a = custom_flavor_a.replace(/\./,'#stop');
          	//custom_flavor_a = custom_flavor_a.replace(/'/,'#accent');         

            //cids[product_id] = custom_flavor_a;

            cjson_str = JSON.stringify(selected_products_array);
				
          	//set custom flavor name cookie
    		newresult ={}
            if(getCookie("selected_cflavor") != null){
                result= getCookie("selected_cflavor");
                result = JSON.parse(result);              	
                newresult = {...result, ...selected_products_array}              
                document.cookie = "selected_cflavor="+JSON.stringify(newresult)+";path="+window.location.pathname;
            }else {
              	document.cookie = "selected_cflavor="+JSON.stringify(selected_products_array)+";path="+window.location.pathname;
            }
    
    		
    		//set cookie for variant id
    		newresult ={}
         	if(getCookie("selected_pyf") != null){
              result= getCookie("selected_pyf");
              result = JSON.parse(result);              	
              newresult = {...result, ...selected_products_array}    
              document.cookie = "selected_pyf="+ JSON.stringify(newresult)+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pyf=" + JSON.stringify(selected_products_array)+";path="+window.location.pathname;
            }
    
    		//console.log('json_str');
    		//console.log(json_str);
	
            var newcon = {};
          	if(getCookie("selected_collection_name") != null){
                result= getCookie("selected_collection_name");
                result = JSON.parse(result);
                newcon[0] = result;
              	newcon[1] = title;
                document.cookie = "selected_collection_name=" + JSON.stringify(newcon)+";path="+window.location.pathname;
            }else{
              	newcon[0] = title;
            	document.cookie = "selected_collection_name=" + JSON.stringify(title)+";path="+window.location.pathname;            
            }
          
            //set product id cookie
            if(getCookie("selected_pints") != null){

              result = getCookie("selected_pints");
              result = result+','+product_index;
              document.cookie = "selected_pints="+ result+";path="+window.location.pathname;
            } else{

              document.cookie = "selected_pints=" + product_index+";path="+window.location.pathname;
            } 
    		
    		//set cookie for variant id
          	if(getCookie("selected_pints_vid") != null){
              result = getCookie("selected_pints_vid");
              result = result+','+product_index;             
              document.cookie = "selected_pints_vid="+ result+";path="+window.location.pathname;
            } else{
              document.cookie = "selected_pints_vid=" + product_index+";path="+window.location.pathname;
            }
    	    	
        }else{          	
        	alert("Maximum Pints Added..");       
        }    
    	    
    	calculate_remain_pack();

  });


 //remove product on Busket click
 $(".pack-collection ul#cup").delegate("li", "click", function(){

    if($(this).hasClass('blank')===false && $(this).hasClass('type-pyf')=== false) {

      var remove_id = $(this).children().children('img').attr('data-id');
      var remove_vid = $(this).children().children('img').attr('data-vid');
      removeProduct(remove_id,remove_vid);
	}
 });


 ///pints selection radio button click Event

 $('.create-block-radio input[name="pints"]').change(function () {

    var count = getCount();
    var pack_8 = 8,pack_4 = 4,pack_12 = 12;
    
   if ($(this).val() == '12_pints') {
      //console.log('12 Pints');
      var remain = pack_12 - count;
      $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text(pack_12);
     
      $('#cup li:gt(0)').css('display','block');
      $('#cup li:gt(11)').css('display','none');

      $('.create-block-radio input.12_pints').prop('checked','checked');
      $('.create-block-radio input.8_pints').prop('checked','');
      $('.create-block-radio input.4_pints').prop('checked','');
      $('.pricing-tag .six-pints').css('display','block');
      $('.pricing-tag .five-pints').css('display','none');
      $('.pricing-tag .four-pints').css('display','none');
      //calculate_remain_pack();

    } else if ($(this).val() == '8_pints') {
      //console.log('8 Pints');
      var remain = pack_8 - count;
      $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text(pack_8);
      
      removeProduct(8);
      $('#cup li:gt(0)').css('display','block');
      $('#cup li:gt(7)').css('display','none');
     
      $('#cup li:gt(7)').each(function(){
      	$(this).children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140');
      	$(this).addClass('blank');
        $(this).removeClass('type-pyf');
        $(this).removeClass('type-pyp');
      });
      $('#list_prod li:gt(7)').remove();
      
      $('.create-block-radio input.8_pints').prop('checked','checked');
      $('.create-block-radio input.4_pints').prop('checked','');
      $('.create-block-radio input.12_pints').prop('checked','');
      $('.pricing-tag .five-pints').css('display','block');
      $('.pricing-tag .four-pints').css('display','none');
      $('.pricing-tag .six-pints').css('display','none');
      //calculate_remain_pack();


    } else{

      var remain = pack_4 - count;
      $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text(pack_4);
      $('#cup li:gt(0)').css('display','block');
      $('#cup li:gt(3)').css('display','none');
      $('.create-block-radio input.4_pints').prop('checked','checked');
      $('.create-block-radio input.8_pints').prop('checked','');
      $('.create-block-radio input.12_pints').prop('checked','');
      $('.pricing-tag .four-pints').css('display','block');
      $('.pricing-tag .five-pints').css('display','none');
      $('.pricing-tag .six-pints').css('display','none');
      
      removeProduct(4);
      $('#cup li:gt(3)').each(function(){
      	$(this).children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140');
      	$(this).addClass('blank');
        $(this).removeClass('type-pyf');
        $(this).removeClass('type-pyp');
      });
       $('#list_prod li:gt(3)').remove();

    }


 });


 //Remove pints event while popup open
 $(document).on('click', '#list_prod li a', function(){

   if($(this).hasClass('type-pyf')=== false){
    var remove_id = $(this).attr('data-id');
   	var remove_vid = $(this).attr('data-vid');
    removeProduct(remove_id,remove_vid);
   }

 });


 //clear pack
 $('#edit_pack_open .edit-pack-footer .clear-pack').on('click', function(){
   	$('body').removeClass('position-popup');
   	$('.create-block-radio-eight').removeAttr('style')
    $('.create-block-radio-four').removeAttr('style')
    $('.create-block-radio-twelve').removeAttr('style')
	window.location ='#';   	
 	removeProduct(0);
 });
 
   //clear pack
 $('#confirm_action .edit-pack-footer .clear-pack').on('click', function(){
   	$('body').removeClass('position-popup');
   	
   	//$('.create-block-radio-eight').removeAttr('style')
    //$('.create-block-radio-four').removeAttr('style')
	 window.location ='#';   	
 	//removeProduct(0);
 });
  
   //finish Editing
 $('#confirm_action .finish-edit').click(function(){
	$('body').removeClass('position-popup');
   	$('.create-block-radio-eight').removeAttr('style')
    $('.create-block-radio-four').removeAttr('style')
    $('.create-block-radio-twelve').removeAttr('style')
	window.location ='#';
   	
 	removeProduct(0);
   addanywayaction()
 });
 
 //finish Editing
 $('#edit_pack_open .finish-edit').click(function(){

   	$('body').removeClass('position-popup');
 	window.location ='#';
 });

  $('#edit_pack').click(function(){

    	$('body').addClass('position-popup');
  });

 ///Hide Popup when clicked outside
 $('div#edit_pack_open').on("click", function (event) {
	if ($(event.target).is('.edit-main-wrap')) {

        $('body').removeClass('position-popup');
      	document.location='#'
	}
 });
  
 $('div.open_popup').on("click", function (event) {
	if ($(event.target).is('.edit-main-wrap')) {

        $('body').removeClass('position-popup');
      	document.location='#'
	}
 });

  //add to cart
  $('#ecre_add_to_cart').click(function(event){

    var selected_pints,selected_ids = {},selected_pints_all,product_name,selected_products=[],length,id,quantity,items,final_items,count;
   	var items, final_items,flag=0,status;
    items = {}; final_items = {};
    
    //start loader
    jQuery('<div class="byi-loader"></div>').prependTo( "body" );

    if($('.create-block-radio input.8_pints').is(':checked')){

      status = 1;
    } else if($('.create-block-radio input.12_pints').is(':checked')){
      status = 2;
    } else {
      status = 0;
   }

    count = getCount();

    if(count < 4 && status == '0'){
		jQuery('body .byi-loader').remove();
      	alert("Please fill 4 pack before add to cart");
      	return false;
    } else if(count < 8 && status == '1' ){
			jQuery('body .byi-loader').remove();
    	alert("Please fill 8 pack before add to cart");
        return false;
    }else if(count < 12 && status == '2' ){
			jQuery('body .byi-loader').remove();
    	alert("Please fill 12 pack before add to cart");
        return false;
    }

    selected_pints = getCookie('selected_pints');
    selected_pints_all = getCookie('selected_pints_all');
    selected_pints_all = JSON.parse(selected_pints_all)


    length = selected_pints.length;

    for ( i=0; i < length;i++){

      id =  selected_pints[i];
      product_name = selected_pints_all[id];
      product_name = product_name.replace(/\|/g, " ");
      product_name = product_name.replace(/\\u0026/g, "&");
                                          
      
      
      // console.log(product_name);
      // console.log(i);
      // console.log(selected_products);
      selected_products[i] = product_name;
	  //console.log(selected_products);
    }
    
    // console.log('final array');
    // console.log(selected_products);
    
    var dd = {Pints : selected_products.join(','),product_id : product_id };
 //    console.log('send data while add to cart');
 //    console.log(dd);
 //    console.log('requested data');
	// console.log({Pints : selected_products.join(','),product_id : product_id },);
                
        
	
    $.ajax({
        type: "POST",
        url: "https://ecreamery-designtool.com/flavorimage/setflavorimage/index/isAjax/1",
        data: {Pints : selected_products.join(','),product_id : product_id },
        dataType : 'json',
        success: function (data) {

          //console.log(data);
         //console.log('response data');
          if(data.status == 'success' && data.design_id != '' ){
              add_to_cart(data.design_id);
          }else{
            alert("Something went wrong");
          }
        }
   });


});

  //add product in cart with all its selected flavor.
  function add_to_cart(design_id){

    var selected_pints,selected_ids = {},selected_pints_all,product_name,selected_products=[],length,id,quantity,items,final_items,count,title;
	
    selected_pints_all = getCookie('selected_pints_all');
    selected_pints = getCookie('selected_pints');
    selected_pints_all = JSON.parse(selected_pints_all)

    length = selected_pints.length;

    for ( i=0; i < length;i++){

      id =  selected_pints[i];
      product_name = selected_pints_all[id];
      product_name = product_name.replace(/\\u0026/g, "&");
      selected_products[i] = product_name;

    }
    
    var pyf = false;
    
    if(getCookie("selected_pyf") != null){      	
    	
    	pyf = false;	  
      
      	var title = getCookie("selected_collection_name");
      	//console.log('title case');
    	//console.log(title);
        if(title != null){ 
          //console.log("parsed");
         // console.log(JSON.parse(title));
          title = JSON.parse(title);
          if( typeof title != 'string' ){
          	title = Object.values(title).join(',');            
          }
          //console.log('final');
         // console.log(title);          	       
        }
    }
       

    selected_pints.forEach(function(element){

        if (!selected_ids[element]) {
            selected_ids[element] = 0;
        }

        selected_ids[element] += 1;
    });

    selected_ids = JSON.stringify(selected_ids);

    if(getCount() <= 4){

      	variant_id = pint_4_id;
    }else if(getCount() <= 8){

      	variant_id = pint_8_id;
    }
    else{

       variant_id = pint_12_id;
    }
    
    
    /*$properties = {
      'Pints' : selected_products.join(', '),
        '_Selected Ids' : selected_ids,
          '_Product Design'	: design_id,
            '_Individual Product' : 'Yes',
              'Product Design': 'No',
    };*/
    
    $properties = {
      '_Product Design'	: design_id,
      '_Individual Product' : 'Yes',      
    };
    $properties['Collection'] = title; 
    
    if(!pyf){
       $properties['Pints'] = selected_products.join(', ');
       $properties['_Selected Ids'] = selected_ids;
       $properties['Product Design'] = "No";
    }else{
       $properties['Collection'] = title;   
       $properties['_Pints'] = selected_products.join(', ');
       $properties['Product Design'] = "No";
    }
    
    
    // console.log('add to cart');
    // console.log(selected_products);
    // console.log(selected_products.join(', '));
    
    
    var params = {
      quantity: 1,
      id: variant_id
    };

    properties = $properties;

    if(properties != false){
      params.properties = properties;
    }


    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: params,
      success: function( response ){
        clearSelectedData();
        window.location='/cart/';   
         //window.location='/collections/personalized-bestselling-pints?scart=true';
      },
      error: function( XMLHttpRequest, textStatus, errorThrown ) {
        response = JSON.parse(XMLHttpRequest.responseText)

        result = response['description'];
        alert(result.replace(' already ',' '));
      }
    });


}

  //Click on Personalise Button

  $('.add-cart-stock .personalise').click(function(){

 	var variant_id,id,count,product_name,selected_ids = {},selected_products = {},length,selected_pints,selected_flavors={},selected_pints_all,selected_cflavor;
    var cflavor_name,final_data = [];   
    if($('.create-block-radio input.8_pints').is(':checked')){

      status = 1;
    } else if($('.create-block-radio input.12_pints').is(':checked')){
      status = 2;
    } else {
      status = 0;
   }

    count = getCount();

    if(count < 4 && status == '0'){

      	alert("Please fill 4 pack before Personalizing");
      	return false;
    } else if(count < 8 && status == '1' ){
    	alert("Please fill 8 pack before Personalizing");
        return false;
    } else if(count < 12 && status == '2' ){
    	alert("Please fill 12 pack before Personalizing");
       return false;
    }

    selected_pints_all = getCookie('selected_pints_all');
    selected_cflavor = getCookie('selected_cflavor');
    selected_pints = getCookie('selected_pints');
    length = selected_pints.length;

    if ( selected_pints_all != null ) {
      selected_pints_all = JSON.parse( selected_pints_all );
    }
    if ( selected_cflavor != null ) {
      selected_cflavor = JSON.parse( selected_cflavor );
    }

    for (var i=0; i < length;i++){
      var tmp_data = {}
      id = selected_pints[i];
      product_name = selected_pints_all[id];
      selected_products[i] = product_name;
      cflavor_name = selected_cflavor[id];
      
      cflavor_name = cflavor_name.replace(/#comma/,',');
      cflavor_name = cflavor_name.replace(/#stop/,'.');
      cflavor_name = cflavor_name.replace(/#accent/,'`');
      
      selected_flavors[i] = cflavor_name;
      tmp_data['id'] = id;
      tmp_data['title'] = product_name;
      tmp_data['custom_title'] = cflavor_name;

      final_data[i] = tmp_data;
    }

    final_data = JSON.stringify(final_data);

    selected_pints.forEach(function(element) {

        if (!selected_ids[element]) {
            selected_ids[element] = 0;
        }

        selected_ids[element] += 1;
    });

    //convert data in json
    selected_products = JSON.stringify(selected_products);
    selected_ids = JSON.stringify(selected_ids);


    if(getCount() <= 4){

      	variant_id = pint_4_id;
    } else if(getCount() <= 8){
      	variant_id = pint_8_id;
    } else{
       variant_id = pint_12_id;
    }

    $('#selected_ids').val(window.btoa(selected_ids));
    $('#selected_custom_flavor').val(window.btoa(final_data));
    $('#selected_products').val(window.btoa(selected_products));
    $('#current_timestamp').val(window.btoa(cur_time));
    $('#sid').val(window.btoa(variant_id));
    $('#ecre-final-data').attr('action',base_url);
    
    var pyf = false;
       
           
    if(getCookie("selected_pyf") != null){
      	
      	pyf = false;     
      	var title = getCookie("selected_collection_name");
     //  	console.log('title case');
    	// console.log(title);
        if(title != null){ 
          // console.log("parsed");
          // console.log(JSON.parse(title));
          title = JSON.parse(title);
          if( typeof title != 'string' ){
          	title = Object.values(title).join(',');            
          }
          // console.log('final');
          // console.log(title);          	       
        }
      	
    	//$('#ecre-final-data').prep
        $('<input type="hidden" name="collection" value="'+title+'">').prependTo( "#ecre-final-data" )
        $('<input type="hidden" name="selected_flavor_type" value="pyf">').prependTo( "#ecre-final-data" )
        $('<input type="hidden" name="selected_custom_flavor_count" value="'+length+'">').prependTo( "#ecre-final-data" )
    }
    
    // console.log("selected Ids");
   	// console.log($('#selected_custom_flavor').val());
    
    clearSelectedData();
    $('form#ecre-final-data').submit();    
          
  });

    //empty selected bucket
    document.cookie = "selected_pints= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    document.cookie = "selected_pints_vid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";

  });


  //change on 19 oct - hide personalized button when user select 24 party cup


   var selectedOption1 = jQuery("#SingleOptionSelector-0").children("option:selected").val()
   var selectedOption2 = jQuery("#SingleOptionSelector-1").children("option:selected").val()

   if(selectedOption1 == '24 party cups' && selectedOption2 == 'Bella' ){

      jQuery("#createown").css('display','none');
    }else{

      jQuery("#createown").css('display','block');
    }



    jQuery("#SingleOptionSelector-1").change(function(){

      var selectedOption1 = $(this).children("option:selected").val();

      var selectedOption2 = jQuery("#SingleOptionSelector-0").children("option:selected").val()

      if(selectedOption1 == 'Bella' && selectedOption2 == '24 party cups' ){

        jQuery("#createown").css('display','none');
      }else{

        jQuery("#createown").css('display','block');
      }

    });

    jQuery("#SingleOptionSelector-0").change(function(){

      var selectedOption1 = $(this).children("option:selected").val();

      var selectedOption2 = jQuery("#SingleOptionSelector-1").children("option:selected").val()

      if(selectedOption2 == 'Bella' && selectedOption1 == '24 party cups' ){
        jQuery("#createown").css('display','none');
      }else{
        jQuery("#createown").css('display','block');
      }
     });


 $('#createown').on('click' ,function(){


      var selected_variant_id = ShopifyAnalytics.meta.selectedVariantId;
      var base,flavor,mix_ins_arr = [],mix_ins_str = '',length,arr = {},final_title_str;
      var selected_products_text,mix_ins,selected_products,seleted_base_id;
	  var designer_url = $(this).attr('data-design-url');

      if(!$('input[name="properties[Base]"]').is(':checked')) {

         alert("Please Select Base Flavor");
         return false;
       }else{

         base = $('input[name="properties[Base]"]:checked').val();
       	 seleted_base_id = $('input[name="properties[Base]"]:checked').attr('data-id');
       }


       if(!$(".flavor input[data-id='"+seleted_base_id+"']").is(':checked')) {

         alert("Please Select Flavor");
         return false;
       }else{

       	 flavor = $(".flavor input[data-id='"+seleted_base_id+"']:checked").val();

       }

		  //to make mix-ins as required field
//        if($('input[name="properties[Mix-ins]"]').val() == '') {

//          alert("Please Select at least one Mix-ins");
//          return false;
//        }


      length = $('.container input[name="Mix-ins"]:checked').length;

      $('.container input[name="Mix-ins"]:checked').each(function(i){

          mix_ins_arr.push($(this).val());

          if(mix_ins_str==''){

            mix_ins_str = $(this).val();
          } else if(i==length-1){

            mix_ins_str = mix_ins_str+' & '+ $(this).val();
          } else{

            mix_ins_str = mix_ins_str+','+ $(this).val();
          }
      });

      final_title_str = '';

      if(flavor != ''){
          final_title_str += flavor;
      }

      if(base != ''){
          final_title_str+= ' '+base;
      }
//calculate_remain_pack();
      if(mix_ins_str != ''){
          final_title_str+= ' with '+ mix_ins_str;
      }

      arr['0'] = final_title_str;
      selected_products_text = JSON.stringify(arr);
      mix_ins = mix_ins_arr.join(',');
      selected_products = '';

     // designer_url = designer_url+selected_variant_id+ '/isAjax/1';
      $('#selected_base').val(window.btoa(base));
      $('#selected_flavor').val(window.btoa(flavor));
      $('#selected_mix_ins').val(window.btoa(mix_ins));
      $('#sid').val(window.btoa(selected_variant_id));
      $('#selected_products').val(window.btoa(selected_products_text));
      $('#current_timestamp').val(window.btoa(cur_time));
      $('#ecre-custom-flavor').attr('action',designer_url);

      $('#ecre-custom-flavor').submit();
  });


  //display mix-ins at cart page
  var tmp_mix_ins_arr = new Array();
  $('input[name="Mix-ins"]').change(function(){

    var $el = $(this);

    setTimeout(function() {
      completely_mix_ins($el);
    }, 100);

  });


  function completely_mix_ins($el){

    $el.each(function(){

    if ($el.is(":checked")) {

      var selected_mix_ins_com = $el.val();
      var tmp_mix_ins_str;
      tmp_mix_ins_str = tmp_mix_ins_str + selected_mix_ins_com+", ";

      tmp_mix_ins_arr.push(selected_mix_ins_com);

    }else{

      var deselected_mix_ins_com = $el.val();
      var index = tmp_mix_ins_arr.indexOf(deselected_mix_ins_com);
      if (index > -1) {
        tmp_mix_ins_arr.splice(index, 1);
      }
    }

    });

    if (tmp_mix_ins_arr.length > 0) {

      var tmp_mix_ins_str = tmp_mix_ins_arr.join(", ");

      $('input[name="properties[Mix-ins]"]').val(tmp_mix_ins_str);

   }else{

   	 $('input[name="properties[Mix-ins]"]').val('');

   }

  }



equalheight = function(container){

  var currentTallest = 0,
       currentRowStart = 0,
       rowDivs = new Array(),
       $el,
       topPosition = 0;
   $(container).each(function() {

     $el = $(this);
     $($el).height('auto')
     topPostion = $el.position().top;

     if (currentRowStart != topPostion) {
       for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
         rowDivs[currentDiv].height(currentTallest);
       }
       rowDivs.length = 0; // empty the array
       currentRowStart = topPostion;
       currentTallest = $el.height();
       rowDivs.push($el);
     } else {
       rowDivs.push($el);
       currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
   });
}

$(window).load(function() {
  equalheight('.grid-view-item__image-wrapper.product-card__image-wrapper');
});


$(window).resize(function(){
  equalheight('.grid-view-item__image-wrapper.product-card__image-wrapper');
});

$(window).load(function() {
   pdata = localStorage.getItem('pickyouritemsdata');

   if(pdata=='picktrue'){
     $('html, body').animate({
          scrollTop: $("div#pickyourflavors").offset().top
      });
   }  
    localStorage.removeItem('pickyouritemsdata');
  
  // setTimeout(function(){
  //   var slideurl = getUrlVars()["scart"];
  //   if ( slideurl != '' && slideurl != null && slideurl != undefined ) {
      
  //     $(".slidecarthq-overlay").removeClass('open');
  //      $(".slidecarthq").removeClass('open');
  //     $(".slidecarthq-overlay").addClass("open");
  //     $(".slidecarthq").addClass("open");
  //     $("#slidecarthq .header button").attr('id', "slidecart-close");
  //   }

  //   $("#slidecart-close").click(function(){
      
  //      $(".slidecarthq-overlay").removeClass('open');
  //      $(".slidecarthq").removeClass('open');
  //      window.location.replace('/collections/personalized-bestselling-pints'); 
  //   }); 
  // },2000);
  
  //  setTimeout(function(){
  //   var slideurl = getUrlVars()["scart"];
  //   if ( slideurl != '' && slideurl != null && slideurl != undefined ) {
  //    // console.log(slideurl);
  //     $(".slidecarthq-overlay").addClass("open");
  //     $(".slidecarthq").addClass("open");
  //     //$("#slidecarthq .header button").addClass("slidecart-close");
  //     $("#slidecarthq .header button").attr('id', "slidecart-close");
  //   }

  //   $("#slidecart-close").click(function(){
  //   //  console.log('close-cart');
  //      $(".slidecarthq-overlay").removeClass('open');
  //      $(".slidecarthq").removeClass('open');
  //      window.location.replace('/collections/personalized-bestselling-pints'); 
  //   }); 
  // },4000);

  // setTimeout(function(){
  //   var slideurl = getUrlVars()["scart"];
  //   if ( slideurl != '' && slideurl != null && slideurl != undefined ) {
      
  //     $(".slidecarthq-overlay").removeClass('open');
  //      $(".slidecarthq").removeClass('open');
  //     $(".slidecarthq-overlay").addClass("open");
  //     $(".slidecarthq").addClass("open");
  //     $("#slidecarthq .header button").attr('id', "slidecart-close");
  //   }

  //   $("#slidecart-close").click(function(){
      
  //      $(".slidecarthq-overlay").removeClass('open');
  //      $(".slidecarthq").removeClass('open');
  //      window.location.replace('/collections/personalized-bestselling-pints'); 
  //   }); 
  // },7000);  
});

function getUrlVars(){
      var vars = [], hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for(var i = 0; i < hashes.length; i++)
      {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = hash[1];
      }
      return vars;
}


//Get the stored cookie
function getCookie(name) {

  var get_data,result = null;

  get_data = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

  if( get_data != null){

    result = get_data[2].split(',');
  }

  return result;

}


//Count stored cookie length
function getCount(){

  var result,length = null;
  result = getCookie("selected_pints_vid");

  if(result != null){
  	length = result.length;
  }

  return length;
}


//Remove product from list and cookie
function removeProduct(remove_id,remove_vid){

  var length,result,value,v_result,v_id;
  length = getCount();
  result = getCookie("selected_pints");
  v_result = getCookie("selected_pints_vid");

  if(remove_id != 0){

    if(remove_id == 4){

      result.splice(4);
      v_result.splice(4);
      
      //empty second selected collection if it is there
	  var second_con = getCookie("selected_collection_name");
      if(second_con != null){
      	tt = JSON.parse(second_con)         
        document.cookie = "selected_collection_name=" + JSON.stringify(tt[0])+";path="+window.location.pathname;      
      }
    }else if(remove_id == 8){
 
      result.splice(8);
      v_result.splice(8);
      
      //empty second selected collection if it is there
	  var second_con = getCookie("selected_collection_name");
      if(second_con != null){
      	tt = JSON.parse(second_con)         
        document.cookie = "selected_collection_name=" + JSON.stringify(tt[0])+";path="+window.location.pathname;      
      }
    }else{
       $('#list_prod li a[data-id="'+remove_id+'"]').each(function(i) {

       if(i == 0 ){

            $(this).parent().remove();
            return false;
          }
       });

        $('.pack-collection ul li a img[data-id="'+remove_id+'"]').each(function(i) {

          if(i == 0 ){

            $(this).parent().parent().remove();
            return false;
          }
        });



        //Append new blank bucket
        $('.pack-collection ul#cup').append('<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li>');

        for (var i=0; i < length;i++){

          value = result[i];
          v_id = v_result[i];

          if(value == remove_id && v_id == remove_vid ){
            result.splice(i, 1);
            v_result.splice(i, 1);
            break;
          }

        }
      	//window.location ='#';
    }

    result.join();
    v_result.join();

    document.cookie = "selected_pints= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
    document.cookie = "selected_pints_vid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;


    if(result != ''){
   	   document.cookie = "selected_pints="+result+";path="+window.location.pathname;
    }
    if(v_result != ''){
   	   document.cookie = "selected_pints_vid="+v_result+";path="+window.location.pathname;
    }


  }

  else{

   //In case of remove all products
   $('#list_prod li').remove();
   $('.pack-collection ul li').remove();

   var blank_li = '<li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li><li class="blank"><a href="javascript:void(0)"><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/empty_bucket.png?6140"></a></li>'
   $('.pack-collection ul#cup').append(blank_li);
   document.cookie = "selected_pints= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
   document.cookie = "selected_pints_vid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
   document.cookie = "selected_pyf= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
   document.cookie = "selected_collection_name= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
    
  }
  calculate_remain_pack(1);

}


function clearSelectedData(){
	 //empty selected bucket
    document.cookie = "selected_pints= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
    document.cookie = "selected_pints_vid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
	document.cookie = "selected_pyf= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
    document.cookie = "selected_collection_name= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
    document.cookie = "selected_collection_name_2= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
    document.cookie = "selected_cflavor= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
    document.cookie = "selected_pints_all= ; expires = Thu, 01 Jan 1970 00:00:00 GMT;path="+window.location.pathname;
}

//Return remaining bucket count
function calculate_remain_pack(data){

	var remain,pack_12 = 12,pack_8 = 8,pack_4 = 4,count,pints;
     count = getCount();





    //top bar show hide
    if(count != null){

      	$('#MainContent .pint-pack-option').css('display','block');

    } else{

      	 $('.create-block-radio input.4_pints').prop('checked','checked');
         $('.create-block-radio input.8_pints').prop('checked','');
         $('.create-block-radio input.12_pints').prop('checked','');
      	 $('#MainContent .pint-pack-option').css('display','none');
   }
  
  
  
  	selected_collection_name = getCookie("selected_collection_name");
    if(selected_collection_name != null){
      col_length = selected_collection_name.length;
    }else{
    	col_length = 0;
    }
  
  //console.log('selected_collection_name length');
  
  
  setTimeout(function(){$('.pack-collection #cup li').each(function(index) {
      //console.log('index');
     // console.log(index);
      if(index == 4){  
        //console.log($(this).hasClass('type-pyf'));        
        //console.log(col_length);
        if($(this).hasClass('type-pyf') && col_length == 1){
			$('.create-block-radio .create-block-radio-four').css('display','none'); 	
        }else{
        	$('.create-block-radio .create-block-radio-four').css('display','inline-block');        
        }
      }
    });},200)
  	
  
  
  	
	
  	// console.log('length for selected_collection_name');
  	// console.log(length);
    if(count > 4 && count != null){
      
     // console.log('inside 15341');
       if(count <= 4){

          remain = pack_4 - count;
          $('.label-need-packs p .remain-pack').text(remain);
          $('.label-need-packs p .total-pack').text(pack_4)
            
          //$('#cup li:gt(3)').css('display','none');
          $('#cup li:gt(0)').css('display','block');
          $('#cup li:gt(3)').css('display','none');
          
          $('.create-block-radio input.4_pints').prop('checked','checked');
          $('.create-block-radio input.8_pints').prop('checked','');
          $('.create-block-radio input.12_pints').prop('checked','');
          $('.pricing-tag .four-pints').css('display','block'); 
          $('.pricing-tag .five-pints').css('display','none');
          $('.pricing-tag .six-pints').css('display','none');
  
      }else if(count <= 8){

          remain = pack_8 - count;
          var remain_mpint= count - 12;
          $('.label-need-packs p .remain-pack').text(remain);
          $('.label-need-packs p .total-pack').text(pack_8)
       
          $('#cup li:gt(0)').css('display','block');
          $('#cup li:gt(7)').css('display','none');
          //$('#cup li:gt('+count+')').css('display','none');
        
          $('.create-block-radio input.8_pints').prop('checked','checked');
          $('.create-block-radio input.4_pints').prop('checked','');
          $('.create-block-radio input.12_pints').prop('checked','');
          $('.pricing-tag .five-pints').css('display','block');
          $('.pricing-tag .four-pints').css('display','none');
          $('.pricing-tag .six-pints').css('display','none');
  
      } else {
          remain = pack_12 - count;
          $('.label-need-packs p .remain-pack').text(remain);
          $('.label-need-packs p .total-pack').text(pack_12);
          
          $('#cup li:gt(0)').css('display','block');
         
          
          $('.create-block-radio input.12_pints').prop('checked','checked');
          $('.create-block-radio input.4_pints').prop('checked','');
          $('.create-block-radio input.8_pints').prop('checked','');
          $('.pricing-tag .six-pints').css('display','block');
          $('.pricing-tag .four-pints').css('display','none');
          $('.pricing-tag .five-pints').css('display','none');
  
      }

    } else if( $('.create-block-radio input.8_pints:checked').length == 1 ){

      if(count <= 4 && data == '1'){

        	remain = pack_4 - count;
        	$('.label-need-packs p .remain-pack').text(remain);
        	$('.label-need-packs p .total-pack').text(pack_4)
         	//$('#cup li:gt(3)').css('display','none');
            $('#cup li:gt(0)').css('display','block');
            $('#cup li:gt(3)').css('display','none');
        	$('.create-block-radio input.4_pints').prop('checked','checked');
        	$('.create-block-radio input.8_pints').prop('checked','');
            $('.create-block-radio input.12_pints').prop('checked','');
        	$('.pricing-tag .four-pints').css('display','block');
        	$('.pricing-tag .five-pints').css('display','none');
            $('.pricing-tag .six-pints').css('display','none');
  
      } else {
  		//console.log('inside 1561')
            remain = pack_8 - count;
    	  	$('.label-need-packs p .remain-pack').text(remain);
        	$('.label-need-packs p .total-pack').text(pack_8);
        	//$('#cup li:gt(3)').css('display','block');
            $('#cup li:gt(0)').css('display','block');
            $('#cup li:gt(7)').css('display','none');
        
        	$('.create-block-radio input.8_pints').prop('checked','checked');
        	$('.create-block-radio input.4_pints').prop('checked','');
            $('.create-block-radio input.12_pints').prop('checked','');
        	$('.pricing-tag .five-pints').css('display','block');
        	$('.pricing-tag .four-pints').css('display','none');
            $('.pricing-tag .six-pints').css('display','none');
  
      }
    } else if( $('.create-block-radio input.12_pints:checked').length == 1 ){

       if(count <= 4 && data == '1'){

        	remain = pack_4 - count;
        	$('.label-need-packs p .remain-pack').text(remain);
        	$('.label-need-packs p .total-pack').text(pack_4)
           	
            //$('#cup li:gt(3)').css('display','none');
             $('#cup li:gt(0)').css('display','block');
              $('#cup li:gt(3)').css('display','none');
        	
            $('.create-block-radio input.4_pints').prop('checked','checked');
        	$('.create-block-radio input.8_pints').prop('checked','');
            $('.create-block-radio input.12_pints').prop('checked','');
        	$('.pricing-tag .four-pints').css('display','block');
        	$('.pricing-tag .five-pints').css('display','none');
            $('.pricing-tag .six-pints').css('display','none');
  
      } else if(count <= 8 && data == '1'){

        	remain = pack_8 - count;
        	$('.label-need-packs p .remain-pack').text(remain);
        	$('.label-need-packs p .total-pack').text(pack_8)
       
            //$('#cup li:gt(3)').css('display','none');
             $('#cup li:gt(0)').css('display','block');
             $('#cup li:gt(7)').css('display','none');
        
            $('.create-block-radio input.8_pints').prop('checked','checked');
        	$('.create-block-radio input.4_pints').prop('checked','');
            $('.create-block-radio input.12_pints').prop('checked','');
        	$('.pricing-tag .five-pints').css('display','block');
        	$('.pricing-tag .four-pints').css('display','none');
            $('.pricing-tag .six-pints').css('display','none');
  
      }else {
  		//console.log('inside 15611')
            remain = pack_12 - count;
      	  	$('.label-need-packs p .remain-pack').text(remain);
        	$('.label-need-packs p .total-pack').text(pack_12);
        	
            //$('#cup li:gt(3)').css('display','block');
             $('#cup li:gt(0)').css('display','block');
             $('#cup li:gt(11)').css('display','none');
        	
            $('.create-block-radio input.12_pints').prop('checked','checked');
        	$('.create-block-radio input.4_pints').prop('checked','');
            $('.create-block-radio input.8_pints').prop('checked','');
        	$('.pricing-tag .six-pints').css('display','block');
        	$('.pricing-tag .four-pints').css('display','none');
            $('.pricing-tag .five-pints').css('display','none');
  
      }
    } else {
      //alert("last else")
      remain = pack_4 - count;
      $('.label-need-packs p .remain-pack').text(remain);
      $('.label-need-packs p .total-pack').text(pack_4);
      $('#cup li:gt(0)').css('display','block');
      $('#cup li:gt(3)').css('display','none');
      $('.create-block-radio input.4_pints').prop('checked','checked');
      $('.create-block-radio input.8_pints').prop('checked','');
      $('.create-block-radio input.12_pints').prop('checked','');
      $('.pricing-tag .four-pints').css('display','block');
      $('.pricing-tag .five-pints').css('display','none');
      $('.pricing-tag .six-pints').css('display','none');

    }



  	//Show currently availabe pints in popup
    if(count == null){

      pints = 0;
    } else{

      pints = count;
    }
  
 //  	console.log('current pack count');
	// console.log(count);
  	$('.current-pack-wrapper').html('<span>'+pints+' Pints currently in Collection</span>');

  	if($('.create-block-radio input.4_pints').is(':checked')) {

    	$('#cup li:lt(4)').css('display','block');
    	return true;
    }else if($('.create-block-radio input.8_pints').is(':checked')) {
      // console.log('8_pints checked');
    	$('#cup li:lt(8)').css('display','block');
    	return true;
    } else{

    	return false;
  	}
 }

//Remain filled while page refresh
function return_real_time_filled_busket(){

	if(getCookie("selected_pints") != null){
  	  var value,result,selected_pints_all,length,product_name,v_id,v_result;
      result = getCookie("selected_pints");
      v_result = getCookie("selected_pints_vid");
      selected_pints_all = getCookie("selected_pints_all");
      length = getCount();

      if ( selected_pints_all != null ) {
        selected_pints_all = JSON.parse( selected_pints_all );
      }
      
      var type = 'pyp';
    
     /* if(getCookie("selected_pyf") != null){
          type = 'pyf';	
        var selected_pyf = getCookie("selected_pyf");
    
      var tot_length =selected_pyf.length;
      if(tot_length == 4){
        $('.create-block-radio-eight').css('display','none')
      }else{
        $('.create-block-radio-four').css('display','none')        
      }
      } */
      
      
      var title = getCookie("selected_collection_name");
     //  	console.log('title case');
    	// console.log(title);
        if(title != null){ 
          // console.log("parsed");
          // console.log(JSON.parse(title));
          title = JSON.parse(title);
          if( typeof title == 'string' && length == 8  ){         
          	$('.create-block-radio .create-block-radio-four').css('display','none');        
          }
          // console.log('final');
          // console.log(title);          	       
        }
	
      // console.log('total length');
      // console.log(length);
      
      for (var i=0; i < length;i++){

        value = result[i];
        v_id = v_result[i];
       	// console.log('inside loop');
        // console.log(i);
        // console.log(v_id);
        
        if(v_id<=8){
        	type = 'pyf';
        }else{
        	type = 'pyp';        
        }
        
        $('.pack-collection ul li.blank:first').children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0085/7168/2893/files/1-12pintpng.png?6500');
        $('.pack-collection ul li.blank:first').children().children('img').attr('data-id',value);
        $('.pack-collection ul li.blank:first').children().children('img').attr('data-vid',v_id);
        $('.pack-collection ul li.blank:first').addClass('type-'+type);
        $('.pack-collection ul li.blank:first').removeClass('blank');

        if(selected_pints_all != null){

          product_name = selected_pints_all[value];
        }

        $('#list_prod').append('<li><a href="javascript:void(0)" class="type-'+type+'" data-vid = "'+v_id+'" data-id= "'+value+'" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+product_name.replace(/\|/g, " ")+'</span></li>');
      }

  }
  
  /*if(getCookie("selected_pyf") != null){
  	  var value,result,selected_pints_all,length,product_name,v_id,v_result;
      //result = getCookie("selected_pints");
      //v_result = getCookie("selected_pints_vid");
      selected_pints_all = getCookie("selected_pints_all");
      var selected_pyf = getCookie("selected_pyf");
    
      var tot_length =selected_pyf.length;
      var selected_pyf_data = JSON.parse( selected_pyf );	

      if ( selected_pints_all != null ) {
        selected_pints_all = JSON.parse( selected_pints_all );
      }

      if(tot_length == 4){
        $('.create-block-radio-eight').css('display','none')
      }else{
        $('.create-block-radio-four').css('display','none')        
      }
       
      for(var data=0; data < selected_pyf.length ; data++  ){
        
        product_name = selected_pyf_data[data];
        $('.pack-collection ul li.blank:first').children().children('img').attr('src','https://cdn.shopify.com/s/files/1/0085/7168/2893/files/1-12pintpng.png?6500');
        $('.pack-collection ul li.blank:first').addClass('type-pyf');        
        $('.pack-collection ul li.blank:first').removeClass('blank');
        $('#list_prod').append('<li><a href="javascript:void(0)" class="type-pyf" data-vid = "" data-id= "" ><img src="https://cdn.shopify.com/s/files/1/0085/7168/2893/files/delete-button.png?6307"></a><span>'+selected_pyf_data[data]+'</span></li>');
       
      }

  } */

}

function disable_pyf_button(){
	$('li.pyf-wrapper').each(function(){
      var desc = $(this).find('.product-card').find('.ecre-desc').find('#hidden-subset');

      if(desc.length > 0){
          desc.text();
          //console.log('length greater')
      }else{
          $(this).find('.product-card').parent('li').remove();
          //console.log('length less');
          $(this).find('.product-card').find('.ecre-actions').find('button').attr('disabled','disabled');
         // console.log('length less');
      }
    });
}